import { useEffect, useState } from "react";
import app from "../components/app";

const userSample = {
  name:"",
  email:"",
  created:"",
  modified:"",
  status:true
}

function Tasks() {
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState(JSON.parse(JSON.stringify(userSample)));
  const [index, setIndex] = useState(null);


  

  useEffect(() => {
    app.fetchGet("/users").then(function(response){
      const nextUsers = [];
      if(response) {
        for(var key in response) {
          nextUsers.push({
            id:key,
            data:response[key]
          })
        }
      }
      
      setUsers(nextUsers);
      console.log(response)
    });
  }, []);
  const addUser = function() {
    if(user.name === "") {
      alert("Please enter Name!");
      return false;
    }
    if(user.email === "") {
      alert("Please enter Name!");
      return false;
    }
    if(index !== null) {
      updateUser();
      return false;
    }
    const created = Date.now();
    user["created"] = created;
    user["modified"] = created;
    app.fetchPost("/users", user).then(function(response){
      console.log(response);
      document.querySelector("#name").value = "";
      document.querySelector("#email").value = "";
      setUsers([...users, {id:response.name, data:user}])
      setUser(JSON.parse(JSON.stringify(userSample)));
    });
  }
  const updateUser = function() {
    user["modified"] = Date.now();
    app.fetchPut(`/users/${users[index].id}`, user).then(function(response){
      console.log(response);
      document.querySelector("#name").value = "";
      document.querySelector("#email").value = "";
      const nextUsers = [...users];
      nextUsers[index].data = user;
      setUsers(nextUsers)
      setUser(JSON.parse(JSON.stringify(userSample)));
      setIndex(null);
    });
  }
  const onInput = function(event){
    const obj = event.currentTarget;
    const nextUser = JSON.parse(JSON.stringify(user));
    nextUser[obj.id] = obj.value.trim();
    setUser(nextUser)
  }
  const editUser = function(index) {
    setIndex(index);
    setUser(users[index].data);
    document.querySelector("#name").value = users[index].data.name;
    document.querySelector("#email").value = users[index].data.email;
  }
  return <div className="container-fluid p-4 task-list">
    <h1>All Users</h1>
    <div className="input-group mb-3 input-group-lg">
  <input type="text" className="form-control" placeholder="Add User Name" id="name" onInput={onInput}  />
  <input type="text" className="form-control" placeholder="Add Email" id="email" onInput={onInput}  />
  <button className="btn btn-secondary" type="button" onClick={addUser}>ADD USER</button>
</div>


    <div className="w-100">
   
    <ul className="list-group">
      {
        users.map(function(v, i){
          return <li key={v.id} className="list-group-item">
            {v.data.name} ({v.data.email})
            <div className="float-end d-flex">
           <div className="btn-group">
           <button type="button" className="btn btn-outline-secondary material-icons" onClick={() => editUser(i)}>edit</button>
  <button type="button" className="btn btn-outline-secondary material-icons" onClick={() => editUser(i)}>delete</button>
</div>
</div>

          </li>
        })
      }
    </ul>

    
    </div>

  </div>
}

export default Tasks;
